export const MODAL = 'MODAL';
export const ADD_TEMPLATE = 'ADD_TEMPLATE';
